module.exports = __webpack_public_path__ + "img/clothes-hanger.e4399d0a.svg";